export const firstLetterUpperCase = (str: string) => {
  const exceptions = ["BMW", "ST"];
  if (str && str.length > 0) {
    if (exceptions.indexOf(str) > -1) {
      return str;
    }
    str = str.toLowerCase();
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  return "";
};

export const upperCaseForEachWord = (str: string) => {
  if (str && str.length > 0) {
    const array = str.split(" ");
    const result = array.map((x) => firstLetterUpperCase(x));
    return result.join(" ");
  }
  return "";
};

export const bankCardFormat = (last4: string) => "**** **** **** " + last4;

export const cardExpiryFormat = (month: number, year: number) =>
  (month < 10 ? "0" + month : month) + "/" + year.toString().substring(2, 4);

export const getRandomString = () => String(Math.random() * 10);

export const cardNumberFormat = (number: string) => {
  var v = number.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
  var matches = v.match(/\d{4,16}/g);
  var match = (matches && matches[0]) || "";
  var parts = [];

  for (let i = 0, len = match.length; i < len; i += 4) {
    parts.push(match.substring(i, i + 4));
  }

  if (parts.length) {
    return parts.join(" ");
  } else {
    return number;
  }
};
